import { render, staticRenderFns } from "./WhatsAppModal.vue?vue&type=template&id=4d4e88da&scoped=true"
import script from "./WhatsAppModal.vue?vue&type=script&lang=ts"
export * from "./WhatsAppModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e88da",
  null
  
)

export default component.exports